import React from "react";
import Button from "../../common/components/Forms/Button/Button";

//styles
import Icon from "../../common/components/Icon/Icon";
import LContainer from "../components/LContainer/LContainer";
import useDataLayer from "../hooks/useDataLayer";

// This shouldn't use any components, as it should work by itself.
// If the issue is with one of the components, then this page will fail.
const ErrorPage: React.FC = () => {
    const { sendPageView } = useDataLayer();
    sendPageView("/compare/react/error");

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#16ae8f"
            }}>
            <LContainer>
                <div className="layout-flex-column--centered">
                    <Icon id="CantFindCamp" width="350px" />

                    <h1 className="text-font-size-ml">Our apologies</h1>
                    <p>
                        Unfortunately, we have encountered an error. You may to resolve
                        this by reloading the page via the button below.
                    </p>
                    <p>
                        If you are still experiencing an issue, please feel free to{" "}
                        <a href="/our-service/contact-us.aspx">contact us</a> and we’ll
                        help you out.
                    </p>

                    <Button
                        component="button"
                        variant="calltoaction"
                        size="m"
                        onClick={() => {
                            window.location.href = "/compare";
                        }}>
                        Reload
                    </Button>
                </div>
            </LContainer>
        </div>
    );
};

export default ErrorPage;
